import type { WizardFlowDefinition } from '@/modules/wizard/types/WizardFlowDefinition'

export const matchingQuizFlow: WizardFlowDefinition = {
  steps: [
    { id: 'ready_to_move' },
    { id: 'study_campus', if: ['readyToMove'] },
    { id: 'course_selection' },
    { id: 'bwl_specialization', if: ['courseSelectionHasBwl'] },
    { id: 'questions' },
    { id: 'intake_interests' },
    { id: 'german_proficiency' },
    { id: 'foreign_languages' },
    { id: 'drivers_license' },
    { id: 'car_availability' },
    { id: 'distance_commute' },
    { id: 'matching_criteria_success' },
  ],
}
